import React from 'react';
import ChatbotLauncher from '../components/custom/ChatbotLauncher';
import { useAuthProvider } from '../providers/AuthProvider';

const ChatbotDemo = () => {
    const { profile } = useAuthProvider();

    return (
        <div style={{ padding: '2rem', minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
            <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                <h1 style={{ textAlign: 'center', marginBottom: '2rem', color: '#333' }}>
                    🤖 AI Chatbot System
                </h1>

                <div style={{ 
                    backgroundColor: 'white', 
                    padding: '2rem', 
                    borderRadius: '12px',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    marginBottom: '2rem'
                }}>
                    <h2 style={{ color: '#007bff', marginBottom: '1rem' }}>Welcome to LogiqOS AI</h2>
                    <p style={{ color: '#666', lineHeight: '1.6', marginBottom: '1.5rem' }}>
                        Our intelligent AI assistant provides comprehensive system management and analytics
                        capabilities for authorized administrators, with secure access to live operational data.
                    </p>

                    {profile?.role === 'admin' ? (
                        <div style={{ marginBottom: '2rem' }}>
                            <div style={{
                                padding: '1.5rem',
                                border: '2px solid #dc3545',
                                borderRadius: '8px',
                                backgroundColor: '#fff5f5'
                            }}>
                                <h3 style={{ color: '#dc3545', marginBottom: '1rem' }}>
                                    🛠️ Admin Assistant Chatbot
                                </h3>
                                <ul style={{ color: '#555', lineHeight: '1.6' }}>
                                    <li>System analytics and performance metrics</li>
                                    <li>Customer management overview</li>
                                    <li>All orders across all customers</li>
                                    <li>Warehouse operations management</li>
                                    <li>Vehicle fleet status and reports</li>
                                </ul>
                                <p style={{ 
                                    marginTop: '1rem', 
                                    padding: '0.5rem',
                                    backgroundColor: '#ffebee',
                                    borderRadius: '4px',
                                    fontSize: '0.9rem',
                                    color: '#c62828'
                                }}>
                                    <strong>⚡ Full Access:</strong> Complete system visibility and control
                                </p>
                            </div>
                        </div>
                    ) : (
                        <div style={{
                            padding: '1.5rem',
                            border: '2px solid #ffc107',
                            borderRadius: '8px',
                            backgroundColor: '#fffbf0',
                            marginBottom: '2rem',
                            textAlign: 'center'
                        }}>
                            <h3 style={{ color: '#856404', marginBottom: '1rem' }}>
                                🔒 AI Assistant Access Restricted
                            </h3>
                            <p style={{ color: '#856404', margin: 0 }}>
                                The AI chatbot is currently available only to administrators for security purposes.
                                Please contact your system administrator if you need assistance.
                            </p>
                        </div>
                    )}

                    <h3 style={{ color: '#333', marginBottom: '1rem' }}>🚀 Getting Started</h3>
                    {profile?.role === 'admin' ? (
                        <ol style={{ color: '#666', lineHeight: '1.6' }}>
                            <li>Click the chatbot button in the bottom-right corner</li>
                            <li>Start chatting! Ask about orders, inventory, or system analytics</li>
                            <li>Use quick action buttons for common administrative queries</li>
                            <li>Access comprehensive system reports and data</li>
                        </ol>
                    ) : (
                        <p style={{ color: '#666', lineHeight: '1.6', fontStyle: 'italic' }}>
                            AI chatbot functionality is currently restricted to administrators only.
                        </p>
                    )}

                    {profile?.role === 'admin' && (
                        <div style={{
                            marginTop: '2rem',
                            padding: '1rem',
                            backgroundColor: '#fff3cd',
                            border: '1px solid #ffeaa7',
                            borderRadius: '6px'
                        }}>
                            <h4 style={{ color: '#856404', marginBottom: '0.5rem' }}>👑 Admin Access</h4>
                            <p style={{ color: '#856404', margin: 0, fontSize: '0.9rem' }}>
                                As an admin, you have full access to the AI assistant for comprehensive 
                                system management, analytics, and operational oversight.
                            </p>
                        </div>
                    )}
                </div>

                <div style={{
                    backgroundColor: 'white',
                    padding: '1.5rem',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    textAlign: 'center'
                }}>
                    <h3 style={{ color: '#28a745', marginBottom: '1rem' }}>✨ AI-Powered Features</h3>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                        gap: '1rem',
                        marginTop: '1rem'
                    }}>
                        <div style={{ padding: '1rem' }}>
                            <span style={{ fontSize: '2rem', display: 'block', marginBottom: '0.5rem' }}>🧠</span>
                            <strong>Natural Language</strong>
                            <br />
                            <small style={{ color: '#666' }}>Understands conversational queries</small>
                        </div>
                        <div style={{ padding: '1rem' }}>
                            <span style={{ fontSize: '2rem', display: 'block', marginBottom: '0.5rem' }}>📊</span>
                            <strong>Live Data</strong>
                            <br />
                            <small style={{ color: '#666' }}>Real-time database integration</small>
                        </div>
                        <div style={{ padding: '1rem' }}>
                            <span style={{ fontSize: '2rem', display: 'block', marginBottom: '0.5rem' }}>🔐</span>
                            <strong>Secure Access</strong>
                            <br />
                            <small style={{ color: '#666' }}>Role-based data restrictions</small>
                        </div>
                        <div style={{ padding: '1rem' }}>
                            <span style={{ fontSize: '2rem', display: 'block', marginBottom: '0.5rem' }}>⚡</span>
                            <strong>Quick Actions</strong>
                            <br />
                            <small style={{ color: '#666' }}>Pre-built common queries</small>
                        </div>
                    </div>
                </div>
            </div>

            {/* Chatbot Launcher */}
            <ChatbotLauncher theme="light" />
        </div>
    );
};

export default ChatbotDemo;